<template>
  <div class="suggestTherapist">
    <div class="titleArea">
      متخصصان حوزه افسردگی سیمیاروم
    </div>
    <div class="descArea mt-2">
      هر روان‌درمانگر متخصص و باتجربه‌ای می‌تواند به شما کمک کند، اما بعضی از آن‌ها به صورت تخصصی روی موضوع افسردگی
      تجربه دارند
      <br>
      و بهترین گزینه برای شما هستند.
    </div>
    <div class="therapists mt-10">
      <div class="therapistsRow">
        <a
            v-for="therapist in therapists"
            :key="therapist.name"
            class="singleTherapist"
            target="_blank"
            :href="therapist.href"
        >
          <div class="imageArea">
            <img :src="therapist.image" :alt="therapist.name">
          </div>
          <div class="nameArea TherapistInterpretation">{{ therapist.name }}</div>
        </a>
      </div>
      <div class="text-center">
        <a target="_blank" href="https://simiaroom.com/pre-session/">
          <v-btn class="mt-5 white--text" elevation="0" color="#46b1a1">
            رزرو وقت مشاوره
          </v-btn>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      therapists: [
        {
          name: 'دکتر عباس رمضانی فرانی',
          href: 'https://simiaroom.com/counselor/%D8%AF%DA%A9%D8%AA%D8%B1-%D8%B9%D8%A8%D8%A7%D8%B3-%D8%B1%D9%85%D8%B6%D8%A7%D9%86%DB%8C-%D9%81%D8%B1%D8%A7%D9%86%DB%8C/',
          image: 'https://api.simiaroom.com/storage/images/6a450fa5edff39.54033509.webp',
        },
        {
          name: 'دکتر ملیحه ایلخانی',
          href: 'https://simiaroom.com/counselor/ilkhani/',
          image: 'https://api.simiaroom.com/storage/images/6a450fb7eb4309.44041284.webp',
        },
        {
          name: 'دکتر مهرنوش اثباتی',
          href: 'https://simiaroom.com/counselor/%D8%AF%DA%A9%D8%AA%D8%B1-%D9%85%D9%87%D8%B1%D9%86%D9%88%D8%B4-%D8%A7%D8%AB%D8%A8%D8%A7%D8%AA%DB%8C/',
          image: 'https://api.simiaroom.com/storage/images/6a451278b545f9.82312823.webp',
        },
      ],
    }
  },
}
</script>

<style scoped>
.suggestTherapist {
  margin-top: 40px;
}

.titleArea {
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}

.descArea {
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}

.therapistsRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 32px 48px;
}

.singleTherapist {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  color: inherit;
  text-decoration: none;
}

.imageArea {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #46b1a1;
}

.imageArea img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.nameArea {
  margin-top: 12px;
  text-align: center;
  color: #4a4a4a;
  font-size: 15px;
  line-height: 1.5;
}

a {
  color: inherit;
  text-decoration: none;
}

@media (max-width: 600px) {
  .suggestTherapist {
    margin-top: 40px !important;
  }

  .therapistsRow {
    gap: 24px 16px;
  }

  .singleTherapist {
    width: 110px;
  }

  .imageArea {
    width: 100px;
    height: 100px;
  }

  .nameArea {
    font-size: 13px;
  }
}
</style>
